import { render, staticRenderFns } from "./groupBtn.vue?vue&type=template&id=3aa14c36"
import script from "./groupBtn.vue?vue&type=script&lang=js"
export * from "./groupBtn.vue?vue&type=script&lang=js"
import style0 from "./groupBtn.vue?vue&type=style&index=0&id=3aa14c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports